import { StyleSheet } from 'react-native';

export const wordleBoardStyles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 7,
    paddingVertical: 8,
  },
  row: {
    flexDirection: 'row',
    gap: 7,
  },
});
